import { Login } from '../../domain/entities/login-entity';
import { LoginRepository } from '../../domain/repositories/login-repository';
import { login } from '../datasources/login';

export class LoginRepositoryImpl implements LoginRepository {
  async Login(email: string, password: string): Promise<Login> {
    const { token, expires_in, token_type } = await login(email, password);

    return new Login(token, expires_in, token_type);
  }
}
